import React, { useEffect, useState } from 'react'

import { Modal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

// Direct download from search (business accounts). Fetches the downloadable
// file list for a single item and renders it as plain GET links pointing at
// the direct-download route, so no rails-ujs / CSRF token is needed on the
// fast listing page. Authorization stays enforced server-side per request.
function DownloadModal({ filesHref, onClose, locale = 'en' }) {
  const t = (key) => i18n.t(`listingPage.download.${key}`, { ns: 'rails', lng: locale })
  const [isLoading, setIsLoading] = useState(true)
  const [title, setTitle] = useState('')
  const [files, setFiles] = useState(EMPTY_ARRAY)

  useEffect(() => {
    let isMounted = true
    setIsLoading(true)

    window
      .fetchJSON(filesHref)
      .then((response) => {
        if (!isMounted) return
        setTitle(response?.title || '')
        setFiles(response?.files || EMPTY_ARRAY)
      })
      .catch(() => {
        if (isMounted) setFiles(EMPTY_ARRAY)
      })
      .finally(() => {
        if (isMounted) setIsLoading(false)
      })

    return () => {
      isMounted = false
    }
  }, [filesHref])

  function renderBody() {
    if (isLoading) {
      return <div className="listing-download-modal__status">{t('loading')}</div>
    }

    if (!files.length) {
      return <div className="listing-download-modal__status">{t('empty')}</div>
    }

    return (
      <ul className="listing-download-modal__list">
        {files.map((file) => (
          <li key={file.id} className="listing-download-modal__item">
            <a className="listing-download-modal__link" href={file.download_url} rel="nofollow">
              {file.name}
            </a>
            <span className="listing-download-modal__size">{file.size}</span>
          </li>
        ))}
      </ul>
    )
  }

  return (
    <Modal
      header={title || t('header')}
      onClose={onClose}
      width="small"
      size="small"
      customClass="listing-download-modal"
    >
      {renderBody()}
    </Modal>
  )
}

DownloadModal.propTypes = {
  filesHref: string.isRequired,
  onClose: func.isRequired,
  locale: string,
}

export default DownloadModal
